document.addEventListener("DOMContentLoaded", function () {

  const container = document.querySelector(".personal-shopper");
  const cards = document.querySelectorAll(".personal-shopper-card");
  const left = document.querySelector(".personal-shopper-arrow--left");
  const right = document.querySelector(".personal-shopper-arrow--right");

  if (!container || !cards.length) return;


  /* PEGA LARGURA DO CARD + GAP */

  function getStep() {

    const card = cards[0];
    const style = window.getComputedStyle(container);

    const gap = parseInt(
      style.columnGap || style.gap || 0
    );

    return card.offsetWidth + gap;

  }


  /* ATUALIZA AS SETAS BASEADO NOS CARDS VISÍVEIS */

  function updateArrows() {

    const containerRect = container.getBoundingClientRect();

    let hasPrevious = false;
    let hasNext = false;


    cards.forEach(function (card) {

      const cardRect = card.getBoundingClientRect();


      /* EXISTE CARD ESCONDIDO À ESQUERDA */

      if (cardRect.left < containerRect.left - 5) {
        hasPrevious = true;
      }


      /* EXISTE CARD ESCONDIDO À DIREITA */

      if (cardRect.right > containerRect.right + 5) {
        hasNext = true;
      }

    });


    /* SETA ESQUERDA */

    if (hasPrevious) {
      left?.classList.remove("hidden");
      left.style.display = "flex";
    } else {
      left?.classList.add("hidden");
      left.style.display = "none";
    }


    /* SETA DIREITA */

    if (hasNext) {
      right?.classList.remove("hidden");
      right.style.display = "flex";
    } else {
      right?.classList.add("hidden");
      right.style.display = "none";
    }

  }


  /* SETA ESQUERDA */

  left?.addEventListener("click", function () {

    container.scrollBy({
      left: -getStep(),
      behavior: "smooth"
    });

  });


  /* SETA DIREITA */

  right?.addEventListener("click", function () {

    container.scrollBy({
      left: getStep(),
      behavior: "smooth"
    });

  });


  /* ATUALIZA DURANTE O SCROLL */

  container.addEventListener("scroll", function () {

    requestAnimationFrame(updateArrows);

  });


  /* ATUALIZA AO REDIMENSIONAR */

  window.addEventListener("resize", function () {

    requestAnimationFrame(updateArrows);

  });


  /* FORÇA INÍCIO DO CARROSSEL */

  container.scrollTo({
    left: 0,
    behavior: "auto"
  });


  /* VERIFICA APÓS O LAYOUT CARREGAR */

  requestAnimationFrame(function () {

    container.scrollTo({
      left: 0,
      behavior: "auto"
    });

    updateArrows();

  });


  window.addEventListener("load", function () {

    setTimeout(function () {

      container.scrollTo({
        left: 0,
        behavior: "auto"
      });

      updateArrows();

    }, 200);

  });

});